import C, { readResponseHeaders as b } from "../util/net.js";
import y from "../common/base-provider.js";
import e from "../managers/braze-instance.js";
import ContentCards from "./content-cards.js";
import { dateFromUnixTimestamp as l } from "../util/date-utils.js";
import { isURIJavascriptOrData as R } from "../util/url-utils.js";
import {
  newCardFromContentCardsJson as N,
  newCardFromSerializedValue as S,
} from "../Card/util/card-factory.js";
import { STORAGE_KEYS as o } from "../managers/storage-manager.js";
import T from "../managers/subscription-manager.js";
import t from "../common/event-logger.js";
import D from "../util/request-header-utils.js";
import { randomInclusive as U } from "../util/math.js";
import { MAX_ERROR_RETRIES_CONTENT_CARDS as k } from "../common/constants.js";
import {
  logger as r,
  IndexedDBAdapter as A,
  EventTypes as i,
} from "../../shared-lib/index.js";
export default class v extends y {
  constructor(t, s, i, h, n) {
    super(),
      (this.yt = t),
      (this.u = s),
      (this.qt = i),
      (this.Jt = h),
      (this.$t = n),
      (this.yt = t),
      (this.u = s),
      (this.qt = i),
      (this.Jt = h),
      (this.$t = n),
      (this.Bt = new T()),
      e.Ht(this.Bt),
      (this.Kt = 0),
      (this.Qt = 0),
      (this.cards = []),
      this.Yt();
    const o = A.ts.Zt;
    new A(o, r).ss(o.hs.es, (t) => {
      this.rs(t);
    }),
      (this.ns = null),
      (this.os = null),
      (this.ls = null),
      (this.us = null),
      (this.cs = null),
      (this.fs = 10),
      (this.ds = 0);
  }
  ps() {
    return this.ns;
  }
  vs(t) {
    this.ns = t;
  }
  ws() {
    return this.os;
  }
  Cs(t) {
    this.os = t;
  }
  Yt() {
    if (!this.u) return;
    const t = this.u.j(o.C.bs) || [],
      s = [];
    for (let i = 0; i < t.length; i++) {
      const e = S(t[i]);
      null != e && s.push(e);
    }
    (this.cards = this.gs(this.ys(s, !1))),
      (this.Kt = this.u.j(o.C.js) || this.Kt),
      (this.Qt = this.u.j(o.C.Rs) || this.Qt);
  }
  Ns(t, s = !1, i = 0, e = 0) {
    let h;
    if (s) {
      h = [];
      for (const t of this.cards) t.test && h.push(t);
    } else h = this.cards.slice();
    for (let i = 0; i < t.length; i++) {
      const e = t[i];
      let r = null;
      for (let t = 0; t < this.cards.length; t++)
        if (e.id === this.cards[t].id) {
          r = this.cards[t];
          break;
        }
      if (s) {
        const t = N(e);
        null != r && r.viewed && t && (t.viewed = !0), null != t && h.push(t);
      } else if (null == r) {
        const t = N(e);
        null != t && h.push(t);
      } else {
        if (!r.Lt(e))
          for (let t = 0; t < h.length; t++)
            if (e.id === h[t].id) {
              h.splice(t, 1);
              break;
            }
      }
    }
    (this.cards = this.gs(this.ys(h, s))),
      this.Ts(),
      (this.Kt = i),
      (this.Qt = e),
      this.u && (this.u.I(o.C.js, this.Kt), this.u.I(o.C.Rs, this.Qt));
  }
  Ss(t) {
    if (this.Ds() && null != t && t.cards) {
      this.u && this.u.I(o.C.Us, e.ks());
      const s = t.full_sync;
      s || this.Yt(),
        this.Ns(t.cards, s, t.last_full_sync_at, t.last_card_updated_at),
        this.Bt.Rt(this.As(!0));
    }
  }
  Fs(t) {
    this.u && this.u.I(o.C.xs, t);
  }
  zs(s, e, h) {
    const r = () => {
        this.qs(e, h, !0);
      },
      n = s ? b(s) : null;
    let l;
    if ((this.Es(), !n || !n["retry-after"])) return void this.Fs(0);
    const a = n["retry-after"];
    if (isNaN(a) && !isNaN(Date.parse(a)))
      (l = Date.parse(a) - new Date().getTime()), l < 0 && r();
    else {
      if (isNaN(parseFloat(a.toString()))) {
        const s =
          "Received unexpected value for retry-after header in /sync response";
        return t.q(i.Ls, { e: s + ": " + a }), void this.Fs(0);
      }
      l = 1e3 * parseFloat(a.toString());
    }
    this.ls = window.setTimeout(() => {
      r();
    }, l);
    let u = 0;
    this.u && (u = this.u.j(o.C.xs)),
      (null == u || isNaN(parseInt(u.toString()))) && (u = 0),
      this.Fs(parseInt(u.toString()) + 1);
  }
  rs(t) {
    var s;
    if (!this.Ds()) return;
    this.Yt();
    const i = this.cards.slice();
    let e = null;
    e = null === (s = this.yt) || void 0 === s ? void 0 : s.getUserId();
    for (let s = 0; s < t.length; s++)
      if (e === t[s].userId || (null == e && null == t[s].userId)) {
        const e = t[s].card;
        let h = null;
        for (let t = 0; t < this.cards.length; t++)
          if (e.id === this.cards[t].id) {
            h = this.cards[t];
            break;
          }
        if (null == h) {
          const t = N(e);
          null != t && i.push(t);
        } else {
          if (!h.Lt(e))
            for (let t = 0; t < i.length; t++)
              if (e.id === i[t].id) {
                i.splice(t, 1);
                break;
              }
        }
      }
    (this.cards = this.gs(this.ys(i, !1))), this.Ts(), this.Bt.Rt(this.As(!0));
  }
  ys(t, s) {
    let i = {},
      e = {},
      h = {};
    this.u &&
      ((i = this.u.j(o.C.v) || {}),
      (e = this.u.j(o.C.H) || {}),
      (h = this.u.j(o.C.A) || {}));
    const r = {},
      n = {},
      l = {};
    for (let s = 0; s < t.length; s++) {
      const o = t[s].id;
      o &&
        (i[o] && ((t[s].clicked = !0), (r[o] = !0)),
        e[o] && ((t[s].viewed = !0), (n[o] = !0)),
        h[o] && ((t[s].dismissed = !0), (l[o] = !0)));
    }
    return (
      s &&
        this.u &&
        (this.u.I(o.C.v, r), this.u.I(o.C.H, n), this.u.I(o.C.A, l)),
      t
    );
  }
  gs(t) {
    const s = [],
      i = new Date();
    let e = {};
    this.u && (e = this.u.j(o.C.A) || {});
    let h = !1;
    for (let n = 0; n < t.length; n++) {
      const o = t[n].url;
      if (!this.Jt && o && R(o)) {
        r.error(
          `Card with url ${o} will not be displayed because Javascript URLs are disabled. Use the "allowUserSuppliedJavascript" option for braze.initialize to enable this card.`,
        );
        continue;
      }
      const l = t[n].expiresAt;
      let a = !0;
      if ((null != l && (a = l >= i), (a = a && !t[n].dismissed), a))
        s.push(t[n]);
      else {
        const s = t[n].id;
        s && (e[s] = !0), (h = !0);
      }
    }
    return h && this.u && this.u.I(o.C.A, e), s;
  }
  Ts() {
    var t;
    const s = [];
    for (let t = 0; t < this.cards.length; t++) s.push(this.cards[t].Y());
    null === (t = this.u) || void 0 === t || t.I(o.C.bs, s);
  }
  Es() {
    this.ls && (clearTimeout(this.ls), (this.ls = null));
  }
  Is() {
    null != this.us && (clearTimeout(this.us), (this.us = null));
  }
  Js(t = 1e3 * this.fs, s, i) {
    this.Is(),
      (this.us = window.setTimeout(() => {
        this.qs(s, i, !0);
      }, t)),
      (this.cs = t);
  }
  qs(t, s, i = !1, h = !0) {
    var r;
    const n = this.$t,
      l = this.u;
    if (!n || !l) return void ("function" == typeof s && s());
    if ((!i && (this.Es(), this.Fs(0)), !this.Ds()))
      return void (
        null === (r = this.qt) ||
        void 0 === r ||
        r.Ms(() => {
          this.qs(t, s);
        })
      );
    h && this.Is();
    const a = n.$s({}, !0);
    l.j(o.C.Us) !== e.ks() && this.Bs(),
      (a.last_full_sync_at = this.Kt),
      (a.last_card_updated_at = this.Qt);
    const u = n.Ps(a, D._s.Xs, i);
    let c = !1;
    n.Gs(
      a,
      (i = -1) => {
        if (this.u) {
          const t = new Date().valueOf();
          D.Hs(this.u, D._s.Xs, t);
        }
        -1 !== i && u.push(["X-Braze-Req-Tokens-Remaining", i.toString()]),
          C.Ks({
            url: `${n.Os()}/content_cards/sync`,
            data: a,
            headers: u,
            L: (i, e) => {
              if (!n.Qs(a, i, u))
                return (c = !0), void ("function" == typeof s && s());
              n.Vs(),
                this.zs(e, t, s),
                this.Ss(i),
                (c = !1),
                D.Ws(this.u, D._s.Xs, 1),
                "function" == typeof t && t();
            },
            error: (t) => {
              n.Ys(t, "retrieving content cards"),
                (c = !0),
                "function" == typeof s && s();
            },
            Zs: () => {
              if (c && h && !this.us && this.ds + 1 < k) {
                D.ti(this.u, D._s.Xs);
                let i = this.cs;
                (null == i || i < 1e3 * this.fs) && (i = 1e3 * this.fs),
                  this.Js(Math.min(3e5, U(1e3 * this.fs, 3 * i)), t, s),
                  (this.ds = this.ds + 1);
              }
            },
          });
      },
      D._s.Xs,
      s,
    );
  }
  As(t) {
    t || this.Yt();
    const s = this.gs(this.cards);
    s.sort((t, s) =>
      t.pinned && !s.pinned
        ? -1
        : s.pinned && !t.pinned
        ? 1
        : t.updated && s.updated && t.updated > s.updated
        ? -1
        : t.updated && s.updated && s.updated > t.updated
        ? 1
        : 0,
    );
    let i = Math.max(this.Qt || 0, this.Kt || 0);
    return (
      0 === i && (i = void 0),
      this.u && this.u.j(o.C.Rs) === this.Qt && void 0 === i && (i = this.Qt),
      new ContentCards(s, l(i))
    );
  }
  si(t) {
    return this.Bt.Nt(t);
  }
  Bs() {
    (this.Kt = 0),
      (this.Qt = 0),
      this.u && (this.u.ii(o.C.js), this.u.ii(o.C.Rs));
  }
  changeUser(t) {
    t ||
      ((this.cards = []),
      this.Bt.Rt(new ContentCards(this.cards.slice(), null)),
      this.u &&
        (this.u.ii(o.C.bs),
        this.u.ii(o.C.v),
        this.u.ii(o.C.H),
        this.u.ii(o.C.A))),
      this.Bs();
  }
  clearData(t) {
    (this.Kt = 0),
      (this.Qt = 0),
      (this.cards = []),
      this.Bt.Rt(new ContentCards(this.cards.slice(), null)),
      t &&
        this.u &&
        (this.u.ii(o.C.bs),
        this.u.ii(o.C.v),
        this.u.ii(o.C.H),
        this.u.ii(o.C.A),
        this.u.ii(o.C.js),
        this.u.ii(o.C.Rs));
  }
  Ds() {
    return (
      !!this.qt && (!!this.qt.ei() || (0 !== this.qt.hi() && this.ri(), !1))
    );
  }
  ri() {
    this.Bt.Rt(new ContentCards([], new Date())), this.u && this.u.ii(o.C.bs);
  }
}
